/**
 * Customers (visitors) resource — dashboard VisitorInfoPane data (ARCHITECTURE §3).
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';
import type { ChatSession, Visitor } from '../../types';

/** Editable visitor identity fields (inline-edit in the cockpit). */
export interface UpdateVisitorBody {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export class CustomersResource {
  constructor(private readonly http: HttpClient) {}

  list(params: { cursor?: string; limit?: number } = {}): Promise<{
    items: Visitor[];
    cursor: string | null;
  }> {
    return this.http.get(endpoints.customers.list(), { query: { ...params } });
  }

  get(customerId: string): Promise<Visitor> {
    return this.http.get(endpoints.customers.detail(customerId));
  }

  /** Inline-edit a visitor's identity (name/email/phone); partial patch. */
  update(customerId: string, patch: UpdateVisitorBody): Promise<Visitor> {
    return this.http.patch(endpoints.customers.detail(customerId), patch);
  }

  /** A visitor's past conversations (newest first) — the cockpit past-chats panel. */
  listChats(
    customerId: string,
    params: { limit?: number } = {},
  ): Promise<{ items: ChatSession[]; cursor: string | null }> {
    return this.http.get(endpoints.customers.chats(customerId), { query: { ...params } });
  }
}
